module.exports = __webpack_public_path__ + "static/media/wrangler-swb.80aa0959.jpg";